export default __webpack_public_path__ + "static/media/KnightHacksLogo.331e4162.svg";